module.exports = __webpack_public_path__ + "static/media/maximize.d41907b0.svg";